import { render } from "./detailAccount.vue?vue&type=template&id=59129155&scoped=true"
import script from "./detailAccount.vue?vue&type=script&lang=js"
export * from "./detailAccount.vue?vue&type=script&lang=js"

import "./detailAccount.vue?vue&type=style&index=0&id=59129155&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59129155"]])

export default __exports__